
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinacija/[slug]",
      function () {
        return require("private-next-pages/destinacija/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinacija/[slug]"])
      });
    }
  